import {
    UserOutlined,
    PhoneOutlined,
    MailOutlined,
    HeartOutlined
  } from '@ant-design/icons';
  
import { Avatar, Checkbox, Input, Modal, Radio } from 'antd';
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";


const UserDetails = forwardRef(({ formData, setFormData }, ref) => {

    const [name, setName] = useState(formData.name || null);
    const [phone, setPhone] = useState(formData.phone || null);
    const [email, setEmail] = useState(formData.email || null);
    const [hasPathologies, setHasPathologies] = useState(formData.hasPathologies || false);
    const [pathologies, setPathologies] = useState(formData.pathologies || null);
    const [acceptedTerms, setAcceptedTerms] = useState(false);

    const [pdfModalVisible, setPdfModalVisible] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');

    const [formErrors, setFormErrors] = useState({});

    useEffect(() => {
        setFormData(prevFormData => ({ ...prevFormData,
            name: name,
            phone: phone,
            email: email,
            pathologies: pathologies
         }));
    }, [name, phone, email, pathologies, setFormData]);

    function validate() {
        const errors = {};

        if (!name) errors.name = "¿Cuál es tu nombre?";

        const phoneRegex = /^(3\d{9}|\d{10})$/;
        if (!phone) {
            errors.phone = "¿Cuál es tu número de celular?";
        } else if (!phoneRegex.test(phone)) {
            errors.phone = "Ingresa un número de celular válido (Colombia: 3XXXXXXXXX, USA: 10 dígitos)";
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            errors.email = "¿Cuál es tu correo electrónico?";
        } else if (!emailRegex.test(email)) {
            errors.email = "Ingresa un correo electrónico válido";
        }

        if (hasPathologies && !pathologies) errors.pathologies = "¿Qué patologias tienes?";

        if (!acceptedTerms) errors.acceptedTerms = "Debes aceptar los Términos y Condiciones y el Consentimiento Informado";

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    }

    useImperativeHandle(ref, ()=>{
        return {
            validate,
        };
    });

    const showPdf = (event, type) => {
    event.preventDefault();
    const pdfFile =
      type === 'terms' ? '/pdf/terms_and_conditions.pdf' : '/pdf/informed_consent.pdf';
    setPdfUrl(pdfFile);
    setPdfModalVisible(true);
  };

    return (
        <>
            <div className="mt-4">
                <div className="m-auto w-100">
                    <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
                        <Avatar size={28} style={{ backgroundColor: 'rgb(67, 5, 68)' }} icon={<UserOutlined />} />
                        <div className="w-75">
                            <Input
                                className="w-100"
                                placeholder="Nombre completo"
                                value={name || ''}
                                onChange={e => setName(e.target.value)}
                            />
                            {formErrors.name && <div style={{ color: 'red' }}>{formErrors.name}</div>}
                        </div>
                    </div>
                    
                    <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
                        <Avatar size={28} style={{ backgroundColor: 'rgb(67, 5, 68)' }} icon={<PhoneOutlined />} />
                        <div className="w-75">
                            <Input
                                className="w-100"
                                placeholder="Número de celular"
                                value={phone || ''}
                                onChange={e => setPhone(e.target.value)}
                            />
                            {formErrors.phone && <div style={{ color: 'red' }}>{formErrors.phone}</div>}    
                        </div>
                    </div>
                    <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
                        <Avatar size={28} style={{ backgroundColor: 'rgb(67, 5, 68)' }} icon={<MailOutlined />} />
                        <div className="w-75">
                            <Input
                                className="w-100"
                                placeholder="Correo electrónico"
                                value={email || ''}
                                onChange={e => setEmail(e.target.value)}
                            />
                            {formErrors.email && <div style={{ color: 'red' }}>{formErrors.email}</div>}    
                        </div>
                    </div>
                    <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
                        <Avatar size={28} style={{ backgroundColor: 'rgb(67, 5, 68)' }} icon={<HeartOutlined />} />
                        <div className="w-75">
                            <label className="mb-1">¿Tienes alguna patología?</label>
                            <Radio.Group
                                value={hasPathologies}
                                onChange={e => {
                                    setHasPathologies(e.target.value);
                                    if (!e.target.value) setPathologies('');
                                }}
                            >
                                <Radio value={false}>No</Radio>
                                <Radio value={true}>Sí</Radio>
                            </Radio.Group>
                        </div>
                    </div>

                    {hasPathologies && (
                        <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-2">
                            <Avatar size={28} style={{ backgroundColor: 'rgba(0, 0, 0, 0)' }} />

                            <div className="w-75">
                                <Input
                                    className="w-100"
                                    placeholder="¿Qué patologías tienes?"
                                    value={pathologies || ''}
                                    onChange={e => setPathologies(e.target.value)}
                                />
                                {formErrors.pathologies && <div style={{ color: 'red' }}>{formErrors.pathologies}</div>}
                            </div>
                        </div>
                    )}

                    <div className="input-group col-12 col-md-5 p-0 mx-auto justify-content-between mt-3 text-center">
                        <Checkbox
                            checked={acceptedTerms}
                            onChange={(e) => setAcceptedTerms(e.target.checked)}
                        >
                            <small>
                            Acepto los{' '}
                            <button
                                type="button"
                                onClick={(event) => showPdf(event, 'terms')}
                                className="link-button"
                            >
                                Términos y Condiciones
                            </button>{' '}
                            y el{' '}
                            <button
                                type="button"
                                onClick={(event) => showPdf(event, 'consent')}
                                className="link-button"
                            >
                                Consentimiento Informado
                            </button>.
                            </small>
                        </Checkbox>
                    </div>
                    {formErrors.acceptedTerms && <div className='text-center' style={{ color: 'red' }}>{formErrors.acceptedTerms}</div>}
                </div>
            </div>
            <Modal
                open={pdfModalVisible}
                footer={null}
                onCancel={() => setPdfModalVisible(false)}
                width={800}
            >
                <iframe title='legal pdf' src={pdfUrl} width="100%" height="500px" />
            </Modal>
      </>
    )
});

export default UserDetails;
